// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-EHnsM";
var _4 = "context-3SXCy";
var _5 = "wrapper__inner-2yYsy";
var _6 = "icon-2-NBv";
var _7 = "title-3FW4C";
var _8 = "text-2bwQZ";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "context", _5 as "wrapper__inner", _6 as "icon", _7 as "title", _8 as "text" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "context": _4, "wrapper__inner": _5, "icon": _6, "title": _7, "text": _8 }
